/* Microsoft Clarity: custom events for key store actions.
   Events show up in Clarity filters ("Custom events") and can be used as funnel steps.
   clarity('upgrade', ...) makes sure sessions with these actions are always fully recorded.
   Loaded from layout/theme.liquid. Added Sep 2026. */
(function () {
  window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  var fired = {};
  function ev(name, upgrade) {
    try {
      window.clarity('event', name);
      if (upgrade && !fired['u_' + name]) { window.clarity('upgrade', name); fired['u_' + name] = 1; }
    } catch (e) {}
  }
  function isCartAdd(url) { return /\/cart\/add(\.js)?(\?|$)/.test(url) && url.indexOf('source=clarity') === -1; }

  // add_to_cart: AJAX (fetch / XHR) adds
  var of = window.fetch;
  if (of) {
    window.fetch = function () {
      var a = arguments, url = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || '';
      var p = of.apply(this, a);
      if (isCartAdd(url)) p.then(function (r) { if (r && r.ok) ev('add_to_cart', true); }).catch(function () {});
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    var url = String(u || '');
    if (isCartAdd(url)) this.addEventListener('load', function () { if (this.status < 400) ev('add_to_cart', true); });
    return oo.apply(this, arguments);
  };

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    // add_to_cart: non-AJAX product form
    if (/\/cart\/add/.test(action)) ev('add_to_cart', true);
    // contact / wholesale application forms
    if (/\/contact/.test(action) || f.id === 'ContactForm' || f.querySelector('input[name="form_type"][value="contact"]')) {
      if (/wholesale/i.test(location.search + ' ' + (f.id || '') + ' ' + (f.className || ''))) ev('b2b_application_submit', true);
      else ev('contact_form_submit', true);
    }
    // begin_checkout: cart form submitted via its checkout button
    if (/\/cart/.test(action) && e.submitter && e.submitter.name === 'checkout') ev('begin_checkout', true);
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('a,button,input[type="submit"]') : null;
    if (!el) return;
    var href = el.getAttribute('href') || '', name = el.getAttribute('name') || '';
    var text = (el.textContent || el.value || '').trim().toLowerCase();
    // begin_checkout: checkout buttons / links, including accelerated checkout buttons
    if (name === 'checkout' || /\/checkout/.test(href) || el.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button')) ev('begin_checkout', true);
    // quote requests
    if (/quote/.test(text) || /quote/i.test(href)) ev('quote_request_click', true);
  }, true);

  // successful contact / application submit (Shopify redirects with contact_posted=true)
  if (/contact_posted=true/.test(location.search)) {
    ev(/wholesale/i.test(location.search) ? 'b2b_application_success' : 'contact_form_success', true);
  }
})();
